import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { FootingAnalysisRequest, FootingAnalysisResponse } from './types';

export function useFootingAnalysisQuery(req: FootingAnalysisRequest) {
  const [debounced, setDebounced] = useState(req);
  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(req), 300);
    return () => window.clearTimeout(t);
  }, [req]);
  return useQuery<FootingAnalysisResponse>({
    queryKey: ['analysis', 'footings', debounced],
    queryFn: async () => (await api.post('/api/analysis/footings', debounced)).data,
    placeholderData: (prev) => prev,
    retry: false,
    staleTime: 60_000,
  });
}
